export default __webpack_public_path__ + "static/media/Share.f9c3f6d8.svg";